export const MENU_WIDTH = 230;
export const MENU_MAX_HEIGHT = 315;
export const MENU_MIN_HEIGHT = 200;

export const labelsPath = () => '/settings/labels' as const;
